import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from 'States/auth/authState';
import Text from 'Components/shared/Text';

const SidebarLink = ({ link }) => {
  const { isAdmin, isAuthenticated } = useContext(AuthContext);
  const {
    route = "",
    href = "",
    text = "",
    onClick = () => { },
    dataQa,
    active,
    enabled = true,
    external = false,
    newTab = false,
    requiresAuth = false,
    adminOnly = false,
    state = {}
  } = link;
  if (
    !enabled
    || (requiresAuth !== isAuthenticated)
    || (adminOnly && !isAdmin)
    || (external && !href)
    || (!external && !route)
  ) {
    return null;
  }
  return (
    <li
      data-qa={dataQa}
      className={`p-16 h3 rounded-l-lg ${active ? 'sidebarLink-active-highlight' : ''}`}
      onClick={onClick}
    >
      {external ? (
        <a
          href={href || undefined}
          target={newTab ? "_blank" : "_self"}
        >
          <Text
            textStyle="h3"
            className="font-extrabold pb-2 border-b border-transparent hover:border-current transition duration-100 ease-in"
            color="color-7"
            inline
          >
            {text}
          </Text>
        </a>
      ) : (
        <Link
          to={{
            pathname: route,
            state
          }}
          target={newTab ? "_blank" : "_self"}
        >
          <Text
            textStyle="h3"
            className="font-extrabold pb-2 border-b border-transparent hover:border-current transition duration-100 ease-in"
            color="color-7"
            inline
          >
            {text}
          </Text>
        </Link>
      )}
    </li>
  );
};

export default SidebarLink;
